import React from "react";

export default function Logo({ size = 40, showText = true, textClass = "" }) {
  return (
    <div className="flex items-center gap-3" data-testid="aura-logo">
      <img
        src="/aura-mark-256.png"
        alt="AURA"
        style={{ width: size, height: size }}
        className="object-contain drop-shadow-[0_0_12px_rgba(0,200,255,0.35)]"
      />
      {showText && (
        <div className={textClass}>
          <div className="heading-font text-lg font-black tracking-tighter leading-none">AURA</div>
          <div className="mono-font text-[9px] tracking-[0.3em] text-white/40 uppercase mt-1">DTTM-001</div>
        </div>
      )}
    </div>
  );
}
